type Props = {
    message?: string;
};

const NoDataFound: React.FC<Props> = ({ message }) => {
    return (
        <div className="flex flex-col items-center justify-between">
            <img src={"/assets/images/illustrations/empty.svg"} height={200} width={200} alt="no process" />
            <h3 className="my-4 text-lg font-semibold text-slate-700">{message || "No Data"}</h3>
        </div>
    );
};

export default NoDataFound;
